(
    function (skyward, $, undefined)
    {
        skyward.dynamicnavigator = skyward.dynamicnavigator || {};
        
        var init = function (selector)
        {
            $(selector + " .dynamicNavigatorWrapper").each(function()
            {
                var navigator = $(this);
                navigator.on("click", ".dynamicNavigatorStepButton:not(.active)", skyward.dynamicnavigator.navigatorStepButtonClick);
                navigator.on("click", ".dynamicNavigatorNextButton", skyward.dynamicnavigator.navigatorNextButtonClick);
                navigator.on("click", ".dynamicNavigatorPreviousButton", skyward.dynamicnavigator.navigatorPreviousButtonClick);
                
                skyward.dynamicnavigator.navigatorStepButtonClick.apply(navigator.find(".dynamicNavigatorStepButton.active"));

                skyward.changeTracking.setUpChangeTracking("#" + navigator.attr("id"));

                resize();
            });
        };

        var processNavigationButtons = function (currentButton)
        {
            var navigator = currentButton.parents(".dynamicNavigatorWrapper");

            var buttonData = currentButton.data();

            if (buttonData.hideNavigationButtons && buttonData.hideNavigationButtons.toString().toLowerCase() == "true")
            {
                navigator.find(".dynamicNavigatorPreviousButton").hide();
                navigator.find(".dynamicNavigatorNextButton").hide();
            }
            else
            {
                if (currentButton.parents(".stepNavigator").first().prev().length < 1)
                {
                    navigator.find(".dynamicNavigatorPreviousButton").hide();
                }
                else
                {
                    navigator.find(".dynamicNavigatorPreviousButton").show();
                }

                if (currentButton.parents(".stepNavigator").first().next().length < 1)
                {
                    navigator.find(".dynamicNavigatorNextButton").hide();
                }
                else
                {
                    navigator.find(".dynamicNavigatorNextButton").show();
                }
            }
        };

        var processCustomButtons = function (currentButton)
        {
            var navigator = currentButton.parents(".dynamicNavigatorWrapper");

            var buttonData = currentButton.data();

            if (!buttonData || !buttonData.customButtons)
            {
                return;
            }

            var customButtonsPlaceHolder = navigator.find(".dynamicNavigatorCustomButtonsPlaceHolder");

            //TODO: Reevaluate button bindings?
            //I think we will need to at some point
            customButtonsPlaceHolder.empty();
            $.each(buttonData.customButtons, function (k, v)
            {
                customButtonsPlaceHolder.append(v);
            });
        };

        skyward.dynamicnavigator.saveContent = function (currentButton)
        {
            var container = currentButton.parents(".dynamicNavigatorWrapper");
            var buttonData = currentButton.data();
            var dynamicNavigatorContent = container.find(".dynamicNavigatorContent");

            var url = skyward.global.virtualDir + buttonData.area + "/" + buttonData.controller + "/" + buttonData.saveAction + "/" + buttonData.id + "/";
            var values = getFieldValues(dynamicNavigatorContent);

            var deferredClick = $.Deferred();

            if (!buttonData.saveAction || !buttonData.saveAction != "")
            {
                skyward.changeTracking.clearDirtyList(container.attr("id"));
                deferredClick.resolve();
            }
            else
            {
                var ajax = $.ajax({
                    url: url,
                    type: "POST",
                    success: async function (data)
                    {
                        skyward.changeTracking.clearDirtyList(container.attr("id"));
                        if (data)
                        {
                            if (data.classNamesToRemove)
                            {
                                $.each(data.classNamesToRemove, function(k, v)
                                {
                                    if (currentButton.hasClass(v))
                                    {
                                        currentButton.removeClass(v);
                                    }
                                });
                            }
                            if (data.classNamesToAdd)
                            {
                                $.each(data.classNamesToAdd, function (k, v)
                                {
                                    if (!currentButton.hasClass(v))
                                    {
                                        currentButton.addClass(v);
                                    }
                                });
                            }

                            if (data.newStatus)
                            {
                                await currentButton.find(".dynamicNavigatorStepStatus").viewpartHtml(data.newStatus);
                            }

                            if (data.updatedResumeNumber)
                            {
                                container.data("updatedResumeNumber", data.updatedResumeNumber);
                            }

                            if (data.redirectURL && data.redirectURL != null)
                            {
                                container.data("redirectURL", data.redirectURL);
                                var redirectURLArray = data.redirectURL.split("/");
                                $.when(skyward.window.loadContent("full", redirectURLArray[0], redirectURLArray[1], redirectURLArray[2], redirectURLArray.length > 3 ? redirectURLArray[3] : null)).done(function()
                                {
                                    deferredClick.resolve();
                                });
                            }
                            else
                            {
                                deferredClick.resolve();
                            }
                        }
                    },
                    error: function ()
                    {
                        deferredClick.resolve();
                    },
                    data: values
                });

                return ajax;
            }
            //todo: handle validation at some point
        };

        var getFieldValues = function (container)
        {
            var values = {};
            container.find("[name]").not(".doNotPost").each(function ()
            {
                var field = $(this);

                var name = field.attr("name");

                if (name == "")
                {
                    return;
                }

                if (field.is("sky-datepicker") && !field.hasClass("filterValue"))
                {
                    // For some reason, details save requires the date in this format
                    values[name] = field.encodedVal();
                }
                else
                {
                    var value = skyward.controls.getValue(field);
                    values[name] = (typeof value == "object") ? JSON.stringify(value) : value;
                }
            });

            container.find(".editablebrowse").each(function ()
            {
                var browse = $(this);
                var name = browse.attr("id");

                values[name] = JSON.stringify(browse.data("editablebrowsedata"));
            });

            container.find(".repeater").each(function ()
            {
                var repeater = $(this);
                var name = repeater.attr("id");

                values[name] = JSON.stringify(repeater.data("savedata"));
            });

            return values;
        };

        skyward.dynamicnavigator.navigatorStepButtonClick = function ()
        {
            var promise = new $.Deferred();

            var button = $(this);

            setTimeout(function ()
            {
                var buttonPadding = 20;
                var buttonLocation = button.offset().left - buttonPadding;
                var scroller = button.parents(".dynamicNavigator").find(".horizontalScroller");
                $(scroller).stop();
                scroller.animate({ scrollLeft: "+=" + buttonLocation }, 800);
            }, 100);

            var buttonData = button.data();
            var navigator = button.parents(".dynamicNavigatorWrapper").first();
            var contentDiv = navigator.find(".dynamicNavigatorContent");
            var currentActiveButton = navigator.find(".dynamicNavigatorStepButton.active");

            $.when(skyward.dynamicnavigator.saveContent(currentActiveButton)).done(function ()
            {
                contentDiv.empty();

                if (navigator.data().redirectURL)
                {
                    promise.resolve();
                    return promise.promise();
                }
                navigator.find(".dynamicNavigatorStepButton.active").removeClass("active");
                button.addClass("active");

                $.when(skyward.window.loadContent(contentDiv.attr("id"), buttonData.area, buttonData.controller, buttonData.action, buttonData.id, buttonData.postData)).done(function()
                {
                    skyward.fieldset.alignTitles("#" + contentDiv.attr("id"));
                    promise.resolve();
                });

                processCustomButtons(button);
                processNavigationButtons(button)
            });

            button.trigger('dynamicNavigatorButtonClick');

            return promise.promise();
        };

        skyward.dynamicnavigator.navigatorNextButtonClick = function ()
        {
            var nextButton = $(this);
            var currentStepButton = nextButton.parents(".dynamicNavigatorWrapper").find(".dynamicNavigatorStepButton.active");
            navigatorNavigationButtonClick(nextButton, "next");
        };

        skyward.dynamicnavigator.navigatorPreviousButtonClick = function ()
        {
            var previousButton = $(this);
            var currentStepButton = previousButton.parents(".dynamicNavigatorWrapper").find(".dynamicNavigatorStepButton.active");
            navigatorNavigationButtonClick(previousButton, "previous");
        };

        var navigatorNavigationButtonClick = function(button, direction)
        {
            var currentStepButton = button.parents(".dynamicNavigatorWrapper").find(".dynamicNavigatorStepButton.active");
            var newStepDiv;
            if (direction == "next")
            {
                newStepDiv = currentStepButton.parents(".stepNavigator").first().next();
            }
            else
            {
                newStepDiv = currentStepButton.parents(".stepNavigator").first().prev();
            }
            newStepDiv.find(".dynamicNavigatorStepButton").click();
        }

        var start = function ()
        {
            skyward.dynamicnavigator.navigatorNextButtonClick.apply($(this));
        };

        var saveAndCompleteLater = function ()
        {
            var savebutton = $(this);
            var saveButtonData = savebutton.data();

            var navigator = savebutton.parents(".dynamicNavigatorWrapper").first();
            var currentActiveButton = navigator.find(".dynamicNavigatorStepButton.active");

            $.when(skyward.dynamicnavigator.saveContent(currentActiveButton)).done(function ()
            {
                if (saveButtonData && saveButtonData.redirectArea && saveButtonData.redirectController && saveButtonData.redirectAction)
                {
                    skyward.window.loadContent("full", saveButtonData.redirectArea, saveButtonData.redirectController, saveButtonData.redirectAction);
                }
            });
        };

        var resume = function () {
            var resumeButton = $(this);
            var resumeButtonData = resumeButton.data();
            var navigator = resumeButton.parents(".dynamicNavigatorWrapper");
            var navigatorData = navigator.data();

            var stepToResumeTo;
            if (navigatorData && navigatorData.updatedResumeNumber)
            {
                stepToResumeTo = $(navigator.find(".step")[navigatorData.updatedResumeNumber]).find(".dynamicNavigatorStepButton");
            }
            else if (!resumeButtonData || !resumeButtonData.resumeNumber)
            {
                stepToResumeTo = $(navigator.find(".step").last()).find(".dynamicNavigatorStepButton");
            }
            else
            {
                stepToResumeTo = $(navigator.find(".step")[resumeButtonData.resumeNumber]).find(".dynamicNavigatorStepButton");
            }

            skyward.dynamicnavigator.navigatorStepButtonClick.apply(stepToResumeTo);
        };

        var submit = function () {
            var button = $(this);
            var buttonData = button.data();

            if (!buttonData.submitArea || !buttonData.submitController || !buttonData.submitAction)
            {
                return;
            }

            var message = "Once you submit, you will not be able to return and make changes.";

            message += '<div class="dynamicNavigatorSubmitPopupDiv">';
            message +=
               '<a class="button chromeless roundedTwoColor secondary floatLeft noHover" data-click-action="dynamicnavigator.submitGoBack"><span class="anchorText buttonText">No, Go Back</span></a>';

            message +=
                '<a class="button chromeless roundedTwoColor primary floatRight noHover" data-click-action="dynamicnavigator.submitCommit"><span class="anchorText buttonText">Yes, Submit</span></a>';
            message += "</div>";

            var options =
            {
                id: "submitPopup",
                additionalDialogClass: "eeee",
                class: "sdf"
            };

            //TODO: come back and see if we can use more framework modal stuff
            var goBackButton = {
                id: "goBackButton", text: "No, Go Back", click: function () { dialog.close(); },
                additionalClasses: "roundedTwoColor primary right button"
            };
            //var submitButton = {
            //    id: "submitButton", text: "Yes, Submit", click: function () { dialog.close(); doSubmit(); },
            //    additionalClasses: "roundedTwoColor primary right button"
            //};
            
            //var dialog = skyward.modalLayer.showDialog('Are you sure?', message, [goBackButton, submitButton], options);

            var dialog = skyward.modalLayer.showInformationBubble('Are you sure?', message, [goBackButton], options);
        };

        var submitGoBack = function()
        {
            //TODO: come back and see if we can use more framework modal stuff
            var button = $(this);
            var modalLayerContainer = button.parents(".modalLayerContainer");
            modalLayerContainer.remove();
        };

        var submitCommit = function()
        {
            //TODO: come back and see if we can use more framework modal stuff
            var submitButton = $(".dynamicNavigatorButton.dynamicNavigatorSubmit");
            var buttonData = submitButton.data();

            if (!buttonData.submitArea || !buttonData.submitController || !buttonData.submitAction) {
                return;
            }
            skyward.window.loadContent("full", buttonData.submitArea, buttonData.submitController, buttonData.submitAction, buttonData.submitId, buttonData.postData);
        };

        var resize = function () {

            $(".dynamicNavigatorWrapper").each(function ()
            {
                var wrapper = $(this);
                var navigatorHeight = wrapper.find(".dynamicNavigator").outerHeight(true);
                wrapper.find(".dynamicNavigatorBody").css("top", navigatorHeight + "px");
            });
        };

        var events =
        {
            'start': start,
            'saveAndCompleteLater': saveAndCompleteLater,
            'resume': resume,
            'submit': submit,
            'submitGoBack': submitGoBack,
            'submitCommit': submitCommit
        };

        skyward.window.registerLayoutResizeCallback(resize);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('dynamicnavigator', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
